const inv2022 = 'https://farming-backend.taskmo.in/inv';

const base_url = 'https://farming-backend.taskmo.in';
const getotp = '/appapi/getotp';
const verifyotp = '/appapi/verifyotptoDelete ';
export { inv2022, base_url, getotp, verifyotp };
